import {FETCH_ARTICLES} from './types';
import axios from 'axios';

export const fetchArticles = () => dispatch =>{
    axios.get('https://gameintourney.com/wp-json/better-rest-endpoints/v1/articles?per_page=100')
    .then(articles=>{
        dispatch({
            type:FETCH_ARTICLES,
            payload:articles.data
        })
    })
    .catch(err=>{
        console.log("Error Fetch Post");
    });
};

// export const setNewPosts = posts => dispatch =>{
//     dispatch({
//         type:SET_NEW_POSTS,
//         payload:posts
//     })
// };

// export const resetNewPost = () => dispatch =>{
//     dispatch({
//         type:RESET_NEW_POST
//     })
// };

// export const createPost = postData => dispatch =>{
//     console.log("POST DATAAAA = ",postData);
//     axios.post('https://jsonplaceholder.typicode.com/posts/',postData)
//     .then(posts=>
//         dispatch({
//             type:NEW_POST,
//             payload:posts.data
//         })
//     )
//     .catch(err=>{
//         console.log("Error Create Post");
//     });
//     dispatch({
//         type:NEW_POST,
//         payload:postData
//     })
// }